import axios from 'axios';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebaseConfig';

export const exchangeCodeForAccessToken = async (code, userId) => {
  // Ajoutez ici vos constantes API
  const YOUR_API_KEY = '569e593596a77f1643cbe585cbaf053a';
  const YOUR_API_SECRET = '9b92900344267493861b2598bcca4a72';
  const YOUR_REDIRECT_URI = 'http://localhost:3000/oauth/callback';

  try {
    // Récupérez les données de l'utilisateur depuis Firebase
    const userRef = doc(db, 'Shopify', userId);
    const docSnap = await getDoc(userRef);

    if (!docSnap.exists()) {
      throw new Error('User data not found in Firebase.');
    }

    const shopifyDomain = docSnap.data().shopifyUrl;

    // Générez dynamiquement l'URL de l'endpoint pour l'échange en fonction du domaine Shopify
    const exchangeTokenUrl = `https://${shopifyDomain}/admin/oauth/access_token`;

    // Paramètres requis pour l'échange
    const params = new URLSearchParams({
      client_id: YOUR_API_KEY,
      client_secret: YOUR_API_SECRET,
      code: code,
    });

    // Faites une requête POST à l'endpoint d'échange
    const response = await axios.post(exchangeTokenUrl, params.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    // Récupérez le jeton d'accès depuis la réponse
    const accessToken = response.data.access_token;

    // Assurez-vous que le jeton d'accès existe
    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    return accessToken; // Renvoyez l'access token une fois obtenu avec succès

  } catch (error) {
    console.error('Error exchanging code for access token:', error);
    throw error;
  }
};